import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import * as THREE from 'three';
import Coordinates from "../../Geographic/Coordinates";
import Extent from "../../Geographic/Extent";
var quaternion = new THREE.Quaternion();

var _center = new THREE.Vector3();

var PlanarTileBuilder = /*#__PURE__*/function () {
  function PlanarTileBuilder() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, PlanarTileBuilder);

    /* istanbul ignore next */
    if (options.projection) {
      console.warn('PlanarTileBuilder projection parameter is deprecated, use crs instead.');
      options.crs = options.crs || options.projection;
    }

    if (options.crs) {
      this.crs = options.crs;
    } else {
      throw new Error('options.crs is mandatory for PlanarTileBuilder');
    }

    this.tmp = {
      coords: new Coordinates('EPSG:4326', 0, 0),
      position: new THREE.Vector3(),
      normal: new THREE.Vector3(0, 0, 1)
    };
    this.uvCount = options.uvCount || 1;
  } // prepare params
  // init projected object -> params.projected


  _createClass(PlanarTileBuilder, [{
    key: "prepare",
    value: function prepare(params) {
      params.nbRow = Math.pow(2, params.zoom + 1.0);
      params.projected = new THREE.Vector3();
    } // get center tile in cartesian 3D

  }, {
    key: "center",
    value: function center(extent) {
      extent.center(this.tmp.coords);

      _center.set(this.tmp.coords.x, this.tmp.coords.y, 0);

      return _center;
    } // get position 3D cartesian

  }, {
    key: "vertexPosition",
    value: function vertexPosition(params) {
      this.tmp.position.set(params.projected.x, params.projected.y, 0);
      return this.tmp.position;
    } // get normal for last vertex

  }, {
    key: "vertexNormal",
    value: function vertexNormal() {
      return this.tmp.normal;
    } // coord u tile to projected

  }, {
    key: "uProjecte",
    value: function uProjecte(u, params) {
      params.projected.x = params.extent.west + u * (params.extent.east - params.extent.west);
    } // coord v tile to projected

  }, {
    key: "vProjecte",
    value: function vProjecte(v, params) {
      params.projected.y = params.extent.south + v * (params.extent.north - params.extent.south);
    }
  }, {
    key: "computeSharableExtent",
    value: function computeSharableExtent(extent) {
      // compute sharable extent to pool the geometries
      // the geometry in common extent is identical to the existing input
      // with a translation
      var sharableExtent = new Extent(extent.crs, 0, Math.abs(extent.west - extent.east), 0, Math.abs(extent.north - extent.south));
      return {
        sharableExtent: sharableExtent,
        quaternion: quaternion,
        position: this.center(extent).clone()
      };
    }
  }]);

  return PlanarTileBuilder;
}();

export default PlanarTileBuilder;